import { UseFormReturn } from 'react-hook-form'
import { Dispatch, SetStateAction } from 'react'
import { Option } from '@organisms/Select'
import { UseCompaniesParams } from '@hooks/useCompanies'
import useJobCleaner from './useJobCleaner'
import { FilterState } from './useItemsFilters'
import useCompaniesJobData from './useCompaniesJobData'
import useFilialsJobData from './useFilialsJobData'
import useDivisionsJobData from './useDivisionsJobData'
import usePositionsJobData from './usePositionsJobData'

export type JobData = {
  options: Option[]
  length: number
  isLoading: boolean
  setFilters: Dispatch<SetStateAction<FilterState>>
  setPage: Dispatch<SetStateAction<number>>
  isDisabled: boolean
}

type ReturnType = Record<
  'company' | 'filial' | 'division' | 'position',
  JobData | null
>

export type UseJobDataForFieldsParamsType = {
  company?: UseCompaniesParams
  fieldNames?: Partial<JobFieldNames>
}

export type JobFieldNames = {
  company: string
  filial: string
  division: string
  position: string
}

export const DEFAULT_JOB_FIELD_NAMES: JobFieldNames = {
  company: 'company',
  filial: 'filial',
  division: 'division',
  position: 'position',
}

const useJobDataForFields = (
  methods: UseFormReturn,
  params?: UseJobDataForFieldsParamsType
): ReturnType => {
  const fieldNames = { ...DEFAULT_JOB_FIELD_NAMES, ...params?.fieldNames }

  useJobCleaner(methods, fieldNames)

  const companiesJobData = useCompaniesJobData(params?.company)
  const filialsJobData = useFilialsJobData(
    methods,
    companiesJobData,
    fieldNames.company
  )
  const divisionsJobData = useDivisionsJobData(
    methods,
    filialsJobData,
    fieldNames.filial
  )
  const positionsJobData = usePositionsJobData(
    methods,
    divisionsJobData,
    fieldNames.division
  )

  return {
    company: companiesJobData,
    filial: filialsJobData,
    division: divisionsJobData,
    position: positionsJobData,
  }
}

export default useJobDataForFields
